import { ACTION_TYPES } from './modalForgetPassword.constant';

export const modalOpen = () => ({
  type: ACTION_TYPES.MODAL_FORGET_PASSWORD_OPEN,
});

export const modalClose = () => ({
  type: ACTION_TYPES.MODAL_FORGET_PASSWORD_CLOSE,
});
